import React from 'react';

const ProductTable = ({ productos, onEdit, onDelete, onShowDetails, selectedRows, onSelectRow, onSelectAll, loading }) => {
  return (
    <div className="overflow-x-auto bg-white rounded shadow">
      <table className="min-w-full text-sm">
        <thead>
          <tr className="bg-gray-200">
            <th><input type="checkbox" onChange={onSelectAll} checked={selectedRows.length === productos.length && productos.length > 0} /></th>
            <th>Código</th>
            <th>Descripción</th>
            <th>Cuenta</th>
            <th>Familia</th>
            <th>Peso (kg)</th>
            <th>Volumen (m³)</th>
            <th>Unidad</th>
            <th>Activo</th>
            <th>Acciones</th>
          </tr>
        </thead>
        <tbody>
          {loading ? (
            <tr><td colSpan={10} className="text-center py-4">Cargando...</td></tr>
          ) : productos.length === 0 ? (
            <tr><td colSpan={10} className="text-center py-4">Sin productos</td></tr>
          ) : productos.map(producto => (
            <tr key={producto.id} className="border-b hover:bg-gray-50">
              <td><input type="checkbox" checked={selectedRows.includes(producto.id)} onChange={() => onSelectRow(producto.id)} /></td>
              <td className="cursor-pointer text-blue-600" onClick={() => onShowDetails(producto)}>{producto.codigo_producto}</td>
              <td>{producto.descripcion}</td>
              <td>{producto.cuenta}</td>
              <td>{producto.familia}</td>
              <td>{producto.peso_kg}</td>
              <td>{producto.volumen_m3}</td>
              <td>{producto.unidad_medida}</td>
              <td>{producto.activo ? 'Sí' : 'No'}</td>
              <td>
                <button className="btn-xs btn-primary mr-1" onClick={() => onEdit(producto)}>Editar</button>
                <button className="btn-xs btn-danger" onClick={() => onDelete(producto)}>Eliminar</button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default ProductTable;
